import Select from "@/components/shared/select/Select";
import { TypeSelectorProps, JsonSchema7Type, jsonSchema7Types } from "./types";

const TYPE_OPTIONS = [
  { value: "string", label: "String" },
  { value: "number", label: "Number" },
  { value: "integer", label: "Integer" },
  { value: "boolean", label: "Boolean" },
  { value: "object", label: "Object" },
  { value: "array", label: "Array" },
  { value: "null", label: "Null" },
];

// Type guard function to check if a string is a valid JsonSchema7Type
function isValidJsonSchema7Type(value: string): value is JsonSchema7Type {
  return jsonSchema7Types.some((type) => type === value);
}

export function TypeSelector({ value, onChange }: TypeSelectorProps) {
  const handleValueChange = (newValue: string) => {
    // Use type guard to ensure the value is a valid JsonSchema7Type
    if (isValidJsonSchema7Type(newValue)) {
      onChange(newValue);
    }
  };

  return (
    <Select
      options={TYPE_OPTIONS}
      value={value}
      onChange={handleValueChange}
      placeholder="Select type"
      size="medium"
    />
  );
}
